import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
const dread_gaze = {
  slug: "dread_gaze",
  name: "Dread Gaze",
  description: "Strike fear into your enemy with a glance",
  abilityIcon: "dread_gaze",
  costs: [
    { stat: "mana", value: 20 }
  ],
  targeting: Targeting.MissileMid,
  cooldown: SEC(8),
  projectileSpeed: 10,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [
            {
              slug: "feared",
              name: "Feared",
              tags: ["debuff", "cc"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "black", "cc"]
};
export {
  dread_gaze
};
//# sourceMappingURL=data:application/json;base64,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
